import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { QueryParamsModel } from '../../../../core/_base/crud';
import { Document } from '../models';
import { DocumentActions, DocumentActionTypes } from '../actions';

export interface DocumentState extends EntityState<Document> {
  totalCount: number;
  query: QueryParamsModel;
  pageLoading: boolean;
  actionLoading: boolean;
  showInitWaitingMessage: boolean;
  error: any;
}

export const adapter: EntityAdapter<Document> = createEntityAdapter<Document>({
  selectId: (document) => document.id,
});

export const initialDocumentState: DocumentState = adapter.getInitialState({
  totalCount: 0,
  query: new QueryParamsModel({}),
  pageLoading: false,
  actionLoading: false,
  showInitWaitingMessage: true,
  error: null,
});

export function documentReducer(
  state = initialDocumentState,
  action: DocumentActions,
): DocumentState {
  switch (action.type) {
    case DocumentActionTypes.ToggleDocumentPageLoading:
      return { ...state, pageLoading: action.payload.pageLoading };

    case DocumentActionTypes.ToggleDocumentActionLoading:
      return { ...state, actionLoading: action.payload.actionLoading };

    case DocumentActionTypes.LoadDocumentPage:
      return adapter.addMany(action.payload.documents, {
        ...initialDocumentState,
        totalCount: action.payload.totalCount,
        query: action.payload.query,
        showInitWaitingMessage: false,
      });

    case DocumentActionTypes.CancelDocumentPage:
      return { ...state, query: new QueryParamsModel({}) };

    case DocumentActionTypes.CreateDocument:
      return adapter.addOne(action.payload.document, state);

    case DocumentActionTypes.UpdateDocument:
      return adapter.updateOne(action.payload.document, state);

    case DocumentActionTypes.ThrowDocumentError:
      return {
        ...state,
        pageLoading: false,
        actionLoading: false,
        error: action.payload.error,
      };

    case DocumentActionTypes.ClearDocumentError:
      return { ...state, error: null };

    default:
      return state;
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
